import { FETCH_ALL_CUSTOMER, CUSTOMER_LOADING, JWT_EXPIRED } from '../actions'

const initialState = {
	loading: false,
	customers: [],
	isJwtExpired: false
}

const handleCustomerReducerCases = (state = initialState, { type, payload }) => {
	switch (type) {
		case FETCH_ALL_CUSTOMER:
			return { ...state, loading: false, customers: payload };

		case CUSTOMER_LOADING:
			return { ...state, loading: true };

		case JWT_EXPIRED:
			return { ...state, isJwtExpired: payload };

		default:
			return state;
	}
}

export default handleCustomerReducerCases;